import React from "react";
import Input from "./Input";

export const driveFilterSelectClass =
  "w-full px-2 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent";

const DriveFilters = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  filters = [],
  total,
  totalLabel = "Total Records",
  columnsClass = "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3",
  searchContainerClass = "w-full max-w-xl",
  afterFilters = null,
}) => {
  const hasFilters =
    filters.length > 0 || typeof total !== "undefined" || !!afterFilters;

  const handleSearchChange = (eventOrValue) => {
    if (!onSearchChange) return;
    const nextValue =
      eventOrValue && eventOrValue.target
        ? eventOrValue.target.value
        : eventOrValue;
    onSearchChange(nextValue);
  };

  return (
    <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
      <div className="mb-4">
        <div className={searchContainerClass}>
          <Input
            name={searchPlaceholder}
            value={searchValue}
            onChange={handleSearchChange}
            type="text"
            width="w-full"
          />
        </div>
      </div>

      {hasFilters && (
        <div className={columnsClass}>
          {filters.map(({ key, label, control }) => (
            <div key={key || label} className="flex flex-col">
              <label className="text-xs font-semibold text-gray-700 mb-1">
                {label}
              </label>
              {control}
            </div>
          ))}

          {afterFilters}

          {typeof total !== "undefined" && (
            <div className="flex flex-col">
              <label className="text-xs font-semibold text-gray-700 mb-1">
                {totalLabel}
              </label>
              <div className="px-2 py-2 border border-transparent bg-white rounded text-sm font-medium text-indigo-600 flex items-center">
                {total}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DriveFilters;
